var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 44.02C35.0457 44.02 44 35.0657 44 24.02C44 12.9743 35.0457 4.02002 24 4.02002C12.9543 4.02002 4 12.9743 4 24.02C4 35.0657 12.9543 44.02 24 44.02Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.8799C19.86 13.8799 16.5 17.2399 16.5 21.3799C16.5 25.4399 19.68 28.7399 23.9 28.8599C23.96 28.8599 24.04 28.8599 24.08 28.8599C24.12 28.8599 24.18 28.8599 24.22 28.8599C24.24 28.8599 24.26 28.8599 24.26 28.8599C28.3 28.7199 31.48 25.4399 31.5 21.3799C31.5 17.2399 28.14 13.8799 24 13.8799Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5614 38.7197C34.0014 41.9997 29.2414 44.0197 24.0014 44.0197C18.7614 44.0197 14.0014 41.9997 10.4414 38.7197C10.9214 36.8997 12.2214 35.2397 14.1214 33.9597C19.5814 30.3197 28.4614 30.3197 33.8814 33.9597C35.8014 35.2397 37.0814 36.8997 37.5614 38.7197Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircle);
export default __webpack_public_path__ + "static/media/profile-circle.006c4c6c3807d343449ae0af1ed9028a.svg";
export { ForwardRef as ReactComponent };